.wrapper {
  position: fixed;
  inset: 0;
  z-index: 15;
  overflow-y: auto;
  background: #fffbf2;
}

.content {
  max-width: 470px;
  padding: 20px 20px 8px 20px;
  margin: 0 auto;
}

.speedCard {
  position: relative;
  width: 100%;
  background: url(./assets/speedCardBg.png) no-repeat;
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 26px 20px;
}

.speedIcn {
  position: absolute;
  top: 0;
  right: 20px;
  width: 18px;
  min-width: 18px;
  height: 18px;
}

.speedValue {
  width: 80px;
  min-width: 80px;
}

.speedText {
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  color: #8F5500;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.08px;
}

.title {
  margin-top: 20px;
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  color:  #221E1A;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
}

.mainCard {
  width: 100%;
  padding: 0 0 8px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
}

.guideImage {
  display: block;
}

.mainWrapper {
  background: #F2EDE1;
  width: 100%;
  padding-bottom: 30px;
  border-radius: 0 0 32px 32px;
}

.benefitsCard {
  position: relative;
  z-index: 5;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 20px;
  border: 4px solid var(--ed-border, #f2ede1);
  border-radius: 32px;
  background: #fffbf2;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 567px) {
    margin: 0 20px;
    width: auto;
  }
}

.benefitRow {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.benefitIconWrap {
  width: 34px;
  min-width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10.767px;
  box-shadow: 3.644px 4.859px 9.69px 0 rgba(255, 255, 255, 0.41) inset;

  img {
    width: 20px;
    min-width: 20px;
  }
}

.iconPotty {
  width: 39.325px;
  height: 39.325px;
}

.iconSquare {
  width: 34.454px;
  height: 34.454px;
  border-radius: 10.767px;
  box-shadow: inset 3.644px 4.859px 9.69px rgba(255, 255, 255, 0.41);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.iconSquareOrange {
  background: #f0930c;
  transform: rotate(8.54deg);
}

.iconSquareGreen {
  background: #29a073;
  transform: rotate(-6.48deg);
}

.iconSquareBlue {
  background: #0e92f0;
  transform: rotate(13.33deg);
}

.iconGlyph {
  width: 20px;
  height: 20px;
}

.iconSquareOrange .iconGlyph {
  transform: rotate(-8.54deg);
}

.iconSquareGreen .iconGlyph {
  transform: rotate(6.48deg);
}

.iconPlusUnion {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 8px;
  top: 8px;
  transform: rotate(-13.33deg);
}

.iconPlusExclude {
  width: 6px;
  height: 6px;
  position: absolute;
  left: 12px;
  top: 13px;
  transform: rotate(-13.33deg);
}

.benefitTextWrap {
  min-width: 0;
}

.benefitTitle {
  margin: 0;
  color: #221e1a;
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.068px;
  font-weight: 600;
}

.benefitDescription {
  margin: 8px 0 0;
  color: #221e1a;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.045px;
}

.boostCard {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 0 20px;
  margin-top: 30px;
  margin-top: 40px;
  border: 1.5px solid var(--ed-border, #29a073);
  border-radius: 32px;
  background: #fffbf2;
  box-shadow: 3px 5px 0 #29a073;
  padding: 24px 28px;
  transform: rotate(-5deg);
  max-width: 305px;
  margin-left: auto;
  margin-right: auto;
}

.boostText {
  width: 100%;
  margin: 0;

  color: #221e1a;
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
}

.boostText span {
  color: #29a073;
}

.boostDot {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -30px;
  pointer-events: none;
}

.boostArrow {
  width: 52px;
  height: 84px;
  // position: absolute;
  // right: 19%;
  // top: 11px;
  pointer-events: none;
}

.priceSummary {
  width: calc(100% - 40px);
  margin-left: auto;
  margin-right: auto;
  margin-top: 32px;
  padding: 16px 0;
  border-top: 2px solid var(--ed-border, #EAE5DA);
  border-bottom: 2px solid var(--ed-border, #eae5da);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.priceRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.priceLabel {
  margin: 0;
  flex: 1 1 auto;
  color: #221e1a;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.051px;
}

.priceValue {
  margin: 0;
  color: #221e1a;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.068px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.discountValue {
  margin: 0;
  color: #e44a08;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.068px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.totalRow {
  padding: 8px;
  border-radius: 12px;
  background: rgba(190, 226, 188, 0.6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.totalLabel {
  margin: 0;
  color: #221e1a;
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0.076px;
  font-weight: 700;
}

.totalValue {
  margin: 0;
  color: #03935d;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.068px;
  font-weight: 700;
  white-space: nowrap;
}

.separator {
  height: 2px;
  width: 100%;
  background: #eae5da;
}

.paymentModalBlock {
  width: 100%;
  padding: 0 20px;
  margin-top: 24px;
}

.paymentModalBlock :global(#paymentModal) {
  padding-top: 0;
}

.paymentModalBlock :global(#paymentModal > h3) {
  margin-bottom: 20px;
  color: #221e1a;
  text-align: center;
  font-family: var(--ed-font-rounded, 'SF Pro Rounded', Nunito, 'Roboto', sans-serif);
  font-size: 22px;
  line-height: 28px;
  letter-spacing: 0.088px;
  font-weight: 700;
}

.paymentModalBlock :global(#paymentModal > div) {
  background: #f2ede1;
  border: 1px solid var(--ed-border, #ddd9cf);
  border-radius: 24px;
  overflow: hidden;
}

.logicPrice {
  display: none;
}